export default ({ request }) => ({
  scmAppraisalGroupListApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/groupList",
      method: "post",
      data,
    });
  },
  scmAppraisalChoiceGroupListApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/choiceGroupList",
      method: "post",
      data,
    });
  },
  scmAppraisalGroupAddApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/groupAdd",
      method: "post",
      data,
    });
  },
  scmAppraisalGroupUpdateApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/groupUpdate",
      method: "post",
      data,
    });
  },
  scmAppraisalGroupDetailApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/groupDetail",
      method: "post",
      data,
    });
  },
  scmAppraisalItemListApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/itemList",
      method: "post",
      data,
    });
  },
  scmAppraisalItemDetailApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/itemDetail",
      method: "post",
      data,
    });
  },
  scmAppraisalItemUpdateApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/itemUpdate",
      method: "post",
      data,
    });
  },
  scmAppraisalItemAddApi(data) {
    return request({
      url: "/digitalCenter/scmAppraisal/itemAdd",
      method: "post",
      data,
    });
  },
});
